const formatter = new Intl.NumberFormat("en-US");
const formatter2 = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2
});

const currency = (amount, dec) =>
  dec ? formatter.format(amount) : formatter2.format(amount);
export default currency;
